/**
 * @generated SignedSource<<f31ba1e44557235673cdf6373ba545c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CourseCategoryOrientation = "LANDSCAPE" | "PORTRAIT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type courseCategoryFragment$data = {
  readonly courses: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"coursePreviewFragment">;
  }>;
  readonly id: string;
  readonly name: string;
  readonly orientation: CourseCategoryOrientation;
  readonly " $fragmentType": "courseCategoryFragment";
};
export type courseCategoryFragment$key = {
  readonly " $data"?: courseCategoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseCategoryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseCategoryFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orientation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        }
      ],
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "courses",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "coursePreviewFragment"
        }
      ],
      "storageKey": "courses(status:\"ACTIVE\")"
    }
  ],
  "type": "CourseCategory",
  "abstractKey": null
};
})();

(node as any).hash = "f611e97e39fdc2019903124bb526f749";

export default node;
